export const TEAL_50 = '#e0f2f1';
export const TEAL_500 = '#009688';

export const RED_50 = '#ffebee';
export const RED_100 = '#FFCDD2';
export const RED_400 = '#EF5350';
export const RED_500 = '#f44336';

export const GREEN_50 = '#E8F5E9';
export const GREEN_100 = '#C8E6C9';
export const GREEN_500 = '#4caf50';

export const BLUE_50 = '#e3f2fd';
export const BLUE_500 = '#2196f3';

export const BLUE_GRAY_50 = '#ECEFF1';
export const BLUE_GRAY_100 = '#CFD8DC';
export const BLUE_GRAY_200 = '#B0BEC5';
export const BLUE_GRAY_300 = '#90A4AE';
export const BLUE_GRAY_400 = '#78909C';
export const BLUE_GRAY_500 = '#607D8B';

export const GRAY_50 = '#FAFAFA';
export const GRAY_200 = '#eeeeee';
export const GRAY_500 = '#9E9E9E';
export const GRAY_600 = '#757575';
export const GRAY_700 = '#616161';
export const GRAY_800 = '#424242';
export const GRAY_900 = '#212121';

export const PRIMARY = '#33ADBD';
export const SECONDARY = '#198DA2';
export const SUCCESS = '#1DD75B';
export const ERROR = '#DE3B40';
export const WARNING = '#EFB034';

export const WHITE = '#FAFAFA';

export const ORANGE_400 = '#FFA726';

export const LIGHT_GREEN_500 = '#8BC34A';
export const LIGHT_BLUE_500 = '#03A9F4';
export const CYAN_500 = '#00BCD4';
export const LIME_500 = '#CDDC39';
export const YELLOW_500 = '#FFEB3B';
export const AMBER_500 = '#FFC107';
export const PURPLE_500 = '#9C27B0';
